import script from "./ModalVerifyAccount.vue?vue&type=script&setup=true&lang=ts"
export * from "./ModalVerifyAccount.vue?vue&type=script&setup=true&lang=ts"

import "./ModalVerifyAccount.vue?vue&type=style&index=0&id=077c3b99&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-077c3b99"]])

export default __exports__